// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1nmz9jpi{word-break:break-all}
._o5726vc6{white-space:pre-line}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/LinkUrl/LinkWarningModal/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,oBAAoB;AAC/B,WAAW,oBAAoB","sourcesContent":["._1nmz9jpi{word-break:break-all}\n._o5726vc6{white-space:pre-line}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
